import 'tippy.js/dist/tippy.css';
import {
  default as MultiSliderCalculatorUI,
  IMultiSliderCalculator,
} from '@monofront/design-system/organisms/MultiSliderCalculator';
import { PrismicLinkContext } from '@monofront/types';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapSliderCalculator } from './mapMultiSliderCalculator';
import { FEATURE_FLAG_PIG_WITHOUT_FREQUENCY } from '@monofront/business/constants';
import { useFeatureIsOn } from '@monofront/business/contexts';

const MultiSliderCalculator: React.FC<IMultiSliderCalculator> = ({
  primary,
  withCheatSheet = false,
}) => {
  const isAbTestEnabled = useFeatureIsOn(FEATURE_FLAG_PIG_WITHOUT_FREQUENCY);

  return (
    <MultiSliderCalculatorUI
      primary={primary}
      context={PrismicLinkContext.SHOP}
      withCheatSheet={withCheatSheet}
      isFrequencyVisible={isAbTestEnabled}
    />
  );
};

export default withSlice(MultiSliderCalculator, mapSliderCalculator);
